import React from "react";
import { connect } from "react-redux";
import Loading from "../../Util/Loading";
import { getListadoMedidasAprobadas, changeSubMenu } from "../actions";
import { Accordion } from "devextreme-react";
import { nombrePlanMovilidad, scrollElementToTop } from "../functions";

import AccordionMedidas from "./accordionMedidas";

class MedidasPlanMovilidad extends React.PureComponent {

  componentDidMount = () => {
    this.props.dispatch(getListadoMedidasAprobadas(this.props.idplanMovilidad));
    scrollElementToTop("medidas-planmovilidad");
  }

  render() {
    return (
      <section id="medidas-planmovilidad">
        { this.props.isMedidasLoading && <Loading /> }

        <div className="row">
          <div className="col-md-8">
            <div className="PM-section-title PM-title">Medidas</div>
          </div>
          <div className="col-md-2 PM-botones-top">
            <button
              className="btn PM-dx-button-plan PM-dx-button-plan-100"
              onClick={() => { this.props.dispatch(changeSubMenu(0)); }}
            >Volver</button>
          </div>
          <div className="col-md-2 PM-botones-top">
            <button
              className="btn PM-dx-button-plan PM-dx-button-plan-100"
              onClick={() => { this.props.dispatch(changeSubMenu(2)); }}
            >Roadmap</button>
          </div>
        </div>

        <div className="panel-group" id="plan" role="tablist" aria-multiselectable="true">
          <div className="panel panel-default PM-borde-tabla">
            <div className="PM-panel-heading-plan PM-fondo-table" role="tab" id="headingOne">
              <h4 className="panel-title">
                <div className="row">
                  <div className="col-sm-7 PM-informativo">
                    <span>Plan</span>
                    <p>{nombrePlanMovilidad(this.props.fechaCreacion,this.props.sucursalId)}</p>
                  </div>
                  <div className="col-sm-3 PM-informativo">
                    <span>Encargado</span>
                    <p>{this.props.nombreusuario}</p>
                  </div>
                  <div className="col-sm-2">
                    <div className="PM-plan-pendientes">
                        En ejecución
                    </div>
                  </div>
                </div>
              </h4>
            </div>

          <Accordion
            dataSource={this.props.medidasPlanMovilidad}
            defaultSelectedIndex={null}
            collapsible
            itemTitleComponent={(data) => (
              <div className="row" style={{ margin: 0 }}>
                <div className="col-sm-10 PM-informativo">
                  <span>Medida:</span>
                  <p style={{ fontSize: 17, color: "#00b2a9" }}>{data.descripcion}</p>
                </div>
                <div className="col-sm-2 text-right" style={{ marginTop: 5 }}>
                  {
                    (data.estadoMedida === 1) ?
                      <div className="PM-plan-finalizada">Finalizado</div>
                      :
                      <div className="PM-plan-pendientes">En ejecución</div>
                  }
                </div>
              </div>
            )}
            itemComponent={(data) => <AccordionMedidas items={data} />}
          />
          </div>
        </div>
        <div className="PM-footer">&nbsp;</div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  medidasPlanMovilidad: state.planMovilidad.medidasPlanMovilidad,
  isMedidasLoading: state.planMovilidad.isMedidasLoading,
  nombreusuario: state.planMovilidad.nombreusuario,
  fechaCreacion: state.planMovilidad.fechaCreacion,
  sucursalId: state.global.sucursalId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(MedidasPlanMovilidad);
